import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
    ':focus': {
      borderBottom: 'none !important',
    },
    ':hover': {
      borderBottom: 'none !important',
      border: 'none !important',
      outline: 'none',
    },
    'input:-webkit-autofill': {
      height: '66px',
      border: '1px solid #C5CED6',
      borderRadius: '112px',
      [theme.breakpoints.down('md')]: {
        borderRadius: '70px',
      },
    },

    '& label': {
      top: '5px !important',
      left: '6px !important',
      '&.Mui-focused': {
        top: '0px !important',
      },
    },
    '& .MuiFilledInput-root': {
      background: 'none !important',
      ':focus': {
        border: 'none !important',
      },
      ':after': {
        border: 'none !important',
      },
      ':before': {
        border: 'none !important',
      },

      'input:-webkit-autofill': {
        height: '66px',
        transition: 'background-color 5000s ease-in-out 0s',
        border: 'none !important',
      },
      'input:-webkit-autofill:hover': {
        height: '66px',
        transition: 'background-color 5000s ease-in-out 0s',
        border: 'none !important',
      },
      'input:-webkit-autofill:focus': {
        height: '66px',
        transition: 'background-color 5000s ease-in-out 0s',
        border: 'none !important',
      },
    },
  },
  formTextfield: {
    width: '100%',
    height: '66px',
    borderRadius: '112px',
    [theme.breakpoints.down('md')]: {
      borderRadius: '70px',
    },
    margin: theme.spacing(3, 0),
    '> *:focus': {
      borderBottom: 'none !important',
    },
    '> *:hover': {
      borderBottom: 'none !important',
      border: 'none !important',
      outline: 'none !important',
    },
    '& .MuiFilledInput-input': {
      width: '100%',
      height: '66px',
      background: theme.custom.whiteColor,
      padding: theme.spacing(0, 4),
      border: '1px solid #C5CED6',
      borderRadius: '112px',
      fontSize: 14,
      [theme.breakpoints.down('md')]: {
        borderRadius: '70px',
      },
    },
  },
}))

export default useStyles
